import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { Select, Tag } from 'antd';
// Local deps
import './RFFSelect.scss';

const Option = Select.Option;

function RFFMultiSelectField({
  input,
  meta,
  labelCol,
  inputCol,
  errorCol,
  label,
  isRequired,
  options,
  mode,
  defaultValue,
  ...otherProps
}) {
  const _OnChange = value => {
    input.onChange(value);
  };

  // Custom tag renderer to prevent text truncation
  /* eslint-disable react/prop-types */
  const customTagRender = (props) => {
    const { label: tagLabel, closable, onClose } = props;
    return (
      <Tag
        closable={closable}
        onClose={onClose}
        style={{
          whiteSpace: 'normal',
          height: 'auto',
          maxWidth: '100%',
          marginBottom: '4px',
          display: 'inline-block'
        }}
      >
        {tagLabel}
      </Tag>
    );
  };
  /* eslint-enable react/prop-types */
  return (
    <div className="nf-rff-input-field">
      <Row className="nf-rff-input-field__row">
        {/* <!-- LABEL --> */}
        {label && (
          <Col {...labelCol}>
            <Label className="nf-rff-input-field__label" htmlFor={input.name}>
              {label}
              {isRequired && (
                <span className="nf-rff-input-field__required">*</span>
              )}
            </Label>
          </Col>
        )}

        {/* <!-- INPUT --> */}
        <Col {...inputCol}>
          <Select
            defaultValue={defaultValue}
            mode={mode}
            // labelInValue //sends the entire object
            className="nf-rff-input-field__input"
            onChange={_OnChange}
            tagRender={mode === 'multiple' ? customTagRender : undefined}
            {...input}
            {...otherProps}
          >
            {options.map(option => (
              <Option value={option.value} key={option.value}>
                {option.text}
              </Option>
            ))}
          </Select>
        </Col>

        {/* <!-- ERROR -> */}
        {meta.touched &&
          meta.error && (
            <Col {...errorCol}>
              <div className="nf-rff-input-field__error">{meta.error}</div>
            </Col>
          )}
      </Row>
    </div>
  );
}

RFFMultiSelectField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
  mode: '',
  defaultValue: [],
};

RFFMultiSelectField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.array.isRequired,
  mode: PropTypes.string,
  defaultValue: PropTypes.string,
};

export default RFFMultiSelectField;



// WEBPACK FOOTER //
// ./src/components/form/RFFMultiSelect/RFFSelect.jsx